function WarningText(text) {
    const style = {
        fontWeight: 'bold',
        color: 'darkorange',
        fontSize: '30px' 
    }

    return <span style={style}>
      {text}
    </span>
}

function EnvironmentWarning() {
    if (document.location.href.includes('sandbox.')) {
        return WarningText('SANDBOX')
    } else if (document.location.href.includes('test.')) {
        return WarningText('TEST')
    } 
    return <></>
}

export default EnvironmentWarning
